export * from '../src/composites/wui-certified-switch/index.js';
//# sourceMappingURL=wui-certified-switch.js.map